import { initMailSyncFlags } from '@mail/flags';
import { logger } from '@mail-core/logger';
import { getCorsApiRPC } from 'reactApp/api/axios.corsapi.rpc';
import { MAIL_HELPERS, USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { FLAGS_MAP } from 'reactApp/modules/mailFlags/constants';

export const initMailFlagsSync = () => {
    try {
        const activeEmail = USER_EMAIL;
        const rpc = getCorsApiRPC();

        initMailSyncFlags(
            { RPC: rpc as any },
            {
                api_v1_helpers: { data: MAIL_HELPERS, error: undefined },
                activeEmail,
                flagsMap: { ...FLAGS_MAP },
            },
            { autoSync: true, onError: (error) => logger.error(error) }
        );
    } catch (error) {
        logger.error(error);
    }
};
